import { useRef, useEffect, memo, ReactNode, Fragment } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import useNavbarHeight from 'store/navbar/useNavbarHeight'

import { enableDocumentScroll } from 'utils/handlerDocumentScroll'

import style from './navbar-bottom-menu.module.scss'
import { navBarItemsBottom } from '../data'
import Image from 'next/image'
import Link from 'next/link'
import { IInfromData } from 'constants/types/navbar.types'
import { Pathname } from 'constants/data'
export interface INavbar {
  noLines?: boolean
  informData?: IInfromData
  isNoAuth?: boolean
  isInformLineHide?: boolean
  children?: ReactNode
  noNavbarItems?: boolean
  phoneItem?: boolean
  onlyLogo?: boolean
  isChildrenLeft?: boolean
  firstVisit?: boolean
}

const NavbarBottomMenu = ({ isInformLineHide, informData, firstVisit }: INavbar) => {
  const navRef = useRef<HTMLDivElement>(null)
  const router = useRouter()
  const { setNavbarHeight } = useNavbarHeight()
  const isCurrentLink = router.asPath

  const isCurrentSection = (link: string, activeRoutes?: string[]) => {
    return (
      isCurrentLink === link ||
      isCurrentLink.includes(link) ||
      (activeRoutes && activeRoutes.includes(isCurrentLink)) ||
      (link === `/${Pathname.LIBRARY}` &&
        (isCurrentLink.includes('article') ||
          (isCurrentLink.includes('video') && !isCurrentLink.includes('videoprojects')) ||
          (isCurrentLink.includes('clinic') &&
            !isCurrentLink.includes('clinical-case') &&
            !isCurrentLink.includes('ai-bolit')) ||
          isCurrentLink.includes('podcast') ||
          isCurrentLink.includes('interactive')))
    )
  }

  useEffect(() => enableDocumentScroll(), [])

  useEffect(() => {
    const height = navRef?.current?.offsetHeight
    if (height) setNavbarHeight(height)
  }, [isInformLineHide, informData?.lineClosed])

  return (
    <>
      <nav ref={navRef} className={style.footer} aria-label={'Нижнее меню'}>
        <div className={style.nav}>
          {navBarItemsBottom.map((item) => {
            return (
              <Fragment key={item.text}>
                <div
                  className={clsx(style.nav_item)}
                  key={item.text}
                  style={{ marginLeft: item.marginLeft }}
                >
                  <Link href={item.link}>
                    <Image
                      src={item.icon}
                      alt={item.text}
                      width={item.imgWidth}
                      height={item.imgHeight}
                      className={clsx(
                        isCurrentSection(item.link, item.activeRoutes) ? style.nav_item_active : ''
                      )}
                    ></Image>
                  </Link>
                </div>
              </Fragment>
            )
          })}
        </div>
      </nav>
    </>
  )
}

export default memo(NavbarBottomMenu)
